import { generateCapsulePath, generateNodePositions, svgConfig } from './utils';
function wrapText(text, maxCharsPerLine) {
  const lines = [];
  for (let i = 0; i < text.length; i += maxCharsPerLine) {
    lines.push(text.slice(i, i + maxCharsPerLine));
  }
  return lines;
}
const RenderNodes = ({ items, rowIndex, color, handleScriptClick }) => {
  const { nodeWidth, nodeHeight, capsuleRadius } = svgConfig;
  const positions = generateNodePositions(items, rowIndex);

  return positions
    .map((node, index) => {
      // 如果是腳本行（rowIndex === 2），檢查腳本是否完整
      if (rowIndex === 2) {
        const script = items.find((item) => item.id === node.id);
        if (
          !script ||
          !script['起始工站'] ||
          !script['移動設備'] ||
          !script['目標工站'] ||
          !script['區段腳本名稱'].trim()
        ) {
          return null;
        }

        // 檢查是否有 segScript (API回傳的資料)
        const hasSegScript = script.segScript;
        const nodeColor = hasSegScript ? color : '#FFFFFF'; // 有 segScript 用原色，沒有用白色
        const textColor = hasSegScript ? 'white' : 'black'; // 有 segScript 用白字，沒有用黑字

        const maxCharsPerLine = 6;
        const lines = wrapText(node.name, maxCharsPerLine);
        const lineHeight = 14;
        const totalHeight = lines.length * lineHeight;
        const verticalPadding = 10;
        const nodeHeight = lines.length * lineHeight + verticalPadding; // 依照行數去算高度
        return (
          <g key={node.id}>
            {/* 可點擊的腳本節點 */}
            <path
              d={generateCapsulePath(
                node.x,
                node.y,
                nodeWidth,
                nodeHeight,
                capsuleRadius,
              )}
              fill={nodeColor}
              stroke="#666"
              strokeWidth="1"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (handleScriptClick) {
                  handleScriptClick(index);
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = '0.8';
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
              }}
            />
            <text
              x={node.x + nodeWidth / 2}
              y={node.y + nodeHeight / 2 - totalHeight / 2 + lineHeight / 2 + 5}
              textAnchor="middle"
              fontSize="12"
              fill={textColor}
              fontWeight="bold"
              style={{ cursor: 'pointer', pointerEvents: 'none' }}
            >
              {lines.map((line, i) => (
                <tspan
                  key={i}
                  x={node.x + nodeWidth / 2}
                  dy={i === 0 ? 0 : lineHeight}
                >
                  {line}
                </tspan>
              ))}
            </text>
          </g>
        );
      }

      // 非腳本節點保持原有樣式
      return (
        <g key={node.id}>
          <path
            d={generateCapsulePath(
              node.x,
              node.y,
              nodeWidth,
              nodeHeight,
              capsuleRadius,
            )}
            fill={color}
            stroke="#666"
            strokeWidth="1"
          />
          <text
            x={node.x + nodeWidth / 2}
            y={node.y + nodeHeight / 2 + 5}
            textAnchor="middle"
            fontSize="12"
            fill="white"
            fontWeight="bold"
          >
            {node.name}
          </text>
        </g>
      );
    })
    .filter(Boolean);
};

export default RenderNodes;
